// SVG ikoonide library — defs block, mille sümboleid kasutatakse <use href="#i-..."> kaudu.
// Port mallist parks_dashboard.py (read 700-715).
// Komponenti kasutatakse üks kord Layout'is (peidetud SVG defs).

export function Icons() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <defs>
        <symbol id="i-sun" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="4.5" fill="currentColor" />
          <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="12" y1="2" x2="12" y2="4.5" />
            <line x1="12" y1="19.5" x2="12" y2="22" />
            <line x1="2" y1="12" x2="4.5" y2="12" />
            <line x1="19.5" y1="12" x2="22" y2="12" />
            <line x1="4.6" y1="4.6" x2="6.4" y2="6.4" />
            <line x1="17.6" y1="17.6" x2="19.4" y2="19.4" />
            <line x1="4.6" y1="19.4" x2="6.4" y2="17.6" />
            <line x1="17.6" y1="6.4" x2="19.4" y2="4.6" />
          </g>
        </symbol>
        <symbol id="i-house" viewBox="0 0 24 24">
          <path
            d="M3 11.5 12 4l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </symbol>
        <symbol id="i-bolt" viewBox="0 0 24 24">
          <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" fill="currentColor" />
        </symbol>
        <symbol id="i-battery" viewBox="0 0 24 24">
          <rect
            x="2.5"
            y="7"
            width="16"
            height="10"
            rx="2.2"
            ry="2.2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <rect x="19.5" y="10" width="2.2" height="4" rx="0.6" fill="currentColor" />
          <rect x="4.5" y="9" width="11.5" height="6" rx="1" fill="currentColor" opacity="0.85" />
        </symbol>
        <symbol id="i-arrow-up" viewBox="0 0 24 24">
          <path d="M12 4 5 12h4v8h6v-8h4z" fill="currentColor" />
        </symbol>
        <symbol id="i-arrow-down" viewBox="0 0 24 24">
          <path d="M12 20 19 12h-4V4H9v8H5z" fill="currentColor" />
        </symbol>
        <symbol id="i-grid" viewBox="0 0 24 24">
          <path
            d="M6 2v6m12-6v6M2 6h20M4 8l4 14m12-14-4 14M9 10l-2 12m10-12 2 12"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </symbol>
        <symbol id="i-refresh" viewBox="0 0 24 24">
          <path
            d="M21 12a9 9 0 0 1-15.5 6.3M3 12a9 9 0 0 1 15.5-6.3"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M21 4v5h-5M3 20v-5h5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
        <symbol id="i-chevron" viewBox="0 0 24 24">
          <path
            d="M6 9l6 6 6-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
        <symbol id="i-warn" viewBox="0 0 24 24">
          <path
            d="M12 3 2 21h20z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <line
            x1="12"
            y1="10"
            x2="12"
            y2="14"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <circle cx="12" cy="17.5" r="1" fill="currentColor" />
        </symbol>
        <symbol id="i-spark" viewBox="0 0 24 24">
          <path
            d="M12 2v6m0 8v6M2 12h6m8 0h6M5 5l4 4m6 6 4 4M5 19l4-4m6-6 4-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </symbol>
      </defs>
    </svg>
  );
}

export default Icons;
